Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowErrors = void 0;
var Localize_1 = require("../../../gen-src/Localize");
var L10n_1 = require("../../localizationUtils/L10n");
var messages_1 = require("../../messages");
var CommonErrorCodes_1 = require("./CommonErrorCodes");
var FlowErrorCodes_1 = require("./FlowErrorCodes");
var FlowErrors;
(function (FlowErrors) {
    function errorMessageFor(errorItem, noDefault) {
        switch (errorItem.errorCode) {
            case CommonErrorCodes_1.CommonErrorCode.CallingUserInsufficientPermissions:
            case FlowErrorCodes_1.FlowErrorCode.FlowMoveInsufficientPermissionsOnDestinationProject:
                return messages_1.Messages.errorFlowInsufficientPermissions();
            case CommonErrorCodes_1.CommonErrorCode.FlowNotFound:
                return messages_1.Messages.errorFlowNotFound({ FLOW_NAME: L10n_1.elideIfLong(errorItem.flowName) });
            case FlowErrorCodes_1.FlowErrorCode.FlowWithSameNameInDestinationProject:
            case FlowErrorCodes_1.FlowErrorCode.FlowNameAlreadyExists:
                return messages_1.Messages.errorFlowNameAlreadyExists();
            case FlowErrorCodes_1.FlowErrorCode.FlowDestinationProjectNotFound:
                return messages_1.Messages.errorFlowDestinationProjectNotFound();
            case FlowErrorCodes_1.FlowErrorCode.FlowDescriptionTooLong:
                return messages_1.Messages.errorFlowDescriptionTooLong({ MAX_LENGTH: Localize_1.Formatters.formatCount(errorItem.maxDescriptionLength) });
            case CommonErrorCodes_1.CommonErrorCode.JobBulked:
                return messages_1.Messages.errorFlowJobBulked();
            default:
                if (!noDefault) {
                    return messages_1.Messages.errorUnknown();
                }
                return '';
        }
    }
    FlowErrors.errorMessageFor = errorMessageFor;
})(FlowErrors = exports.FlowErrors || (exports.FlowErrors = {}));
//# sourceMappingURL=FlowErrors.js.map